enum InterestBaseRate {
    BOE = 1,
    SONIA = 2,
}
export default InterestBaseRate